import { useStorage } from 'hooks'
import { createContext, Dispatch, SetStateAction, useEffect } from 'react'
import { jwtDecode } from 'jwt-decode'
import axios from 'axios'
import { CONNECTION } from 'configs/configs.js'

interface AuthContextType {
  setToken: Dispatch<SetStateAction<string>>
  token: string
  signin: (_newToken: string, _callback: VoidFunction) => any
  signout: (_callback: VoidFunction) => void
  user: {
    status: any
    issuer: string
    audience: string
    user: {
      client: string
      key: string
      level: string
      profilePic: any
      sector: string
      status: string
    }
    iat: number
    exp: number
  }
}

interface IdecodedUser {
  payload: {
    issuer: string
    audience: string
    user: {
      client: string
      key: string
      level: string
      profilePic: any
      sector: string
      status: string
    }
    iat: number
    exp: number
  }
}

export const AuthContext = createContext<AuthContextType>(null!)

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [token, setToken] = useStorage('Token')
  const [user, setUser] = useStorage('User')
  const [colaboradores, setColaboradores] = useStorage('Colaboradores')
  const [especialistas, setEspecialistas] = useStorage('Especialistas')
  const [gestores, setGestores] = useStorage('Gestores')
  const [gestSpec, setGestSpec] = useStorage('GestSpec')

  const signin = async (newToken: any, callback: VoidFunction) => {
    const decodedUser: IdecodedUser = jwtDecode(newToken)
    setUser(decodedUser.payload)
    setToken(newToken)
    const opt = { headers: { Authorization: `Bearer ${newToken}` } }
    const colab = await axios.get(`${CONNECTION.URL}/gestor/gestor`, opt)

    const types: any = {
      GESTOR: String([0, 0, 0, 0, 1, 0, 0, 0, 0]),
      SPECIALIST: String([0, 0, 1, 0, 0, 0, 0, 0, 0]),
      GESTOR_SPECIALIST: String([0, 0, 1, 0, 1, 0, 0, 0, 0]),
    }
    const list: [] = colab.data.data
    ;[
      [setGestores, 'GESTOR'],
      [setEspecialistas, 'SPECIALIST'],
      [setGestSpec, 'GESTOR_SPECIALIST'],
    ].forEach((pair) => {
      const [l, k]: any = pair
      const gList = list
        .filter((usr: any) => String(usr.level) === types[k])
        .map((item: any) => {
          return { ...item, label: item.name, value: item.id }
        })
      // value[l].set(gList)
      l(gList)
    })
    setColaboradores(colab.data.data)

    callback()
    return decodedUser.payload
  }

  const signout = (callback: VoidFunction) => {
    setToken(null)
    setUser(null)
    setColaboradores(null)
    setEspecialistas(null)
    setGestores(null)
    setGestSpec(null)
    callback()
  }

  useEffect(() => {
    if (!token) return
    const decodedUser: IdecodedUser = jwtDecode(token)
    setUser(decodedUser.payload)
  }, [token])

  const value = {
    token,
    setToken,
    signin,
    signout,
    user,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
